import { createSelector } from 'reselect';

// selectors
const getLanguage = (state) => state.config?.language;
const getDeviceInteraction = (state) => state.config?.deviceInteraction;
const getLinescore = createSelector((state) => state.gumbo?.liveData?.linescore || {}, (linescore) => linescore);
const getPlaysData = createSelector((state) => state.gumbo?.liveData?.plays || {}, (plays) => plays);
const getCurrentBatSide = (state) => getPlaysData(state).currentPlay?.matchup?.batSide;
const getBatter = (state) => getLinescore(state).offense?.batter;
const getPitcher = (state) => getLinescore(state).defense?.pitcher;
const getAbstractGameCode = (state) => state?.gumbo?.gameData?.status?.abstractGameCode || '';

// reselect function
export const getPlayerMatchupState = createSelector(
    [getLanguage, getBatter, getPitcher, getCurrentBatSide, getAbstractGameCode, getDeviceInteraction],
    (language, batter, pitcher, currentBatSide, abstractGameCode, deviceInteraction) => (
        {
            language,
            batter,
            pitcher,
            currentBatSide,
            abstractGameCode,
            deviceInteraction
        }
    )
);
